<template>
  <div class="d-flex justify-content-center vh-10">
    <div :class="spinnerClass" role="status" aria-live="polite"></div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    variant: {
      type: String,
      default: 'primary' // Bootstrap 5 color: primary, secondary, success, danger, warning, info, light, dark
    },
    size: {
      type: String,
      default: "sm"
    }
  },
  computed: {
    spinnerClass() {
      const classes = ['spinner-border', `text-${this.variant}`];
      if (this.size) classes.push(`spinner-border-${this.size}`);
      return classes;
    }
  }
}
</script>